import styled from 'styled-components';

export const PendingSessionsGameModalContainer = styled.div`
  padding: 16px;
`;
